import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import auth from "@/store/modules/auth";
import usuario from "@/store/modules/usuario";
import projeto from "./modules/projeto";
import logicaIntervencao from "@/store/modules/logicaIntervencao";
import indicador from "@/store/modules/indicador";
import monitoramento from "@/store/modules/monitoramento";
import enums from "@/store/modules/enums";
import notification from './modules/notification.js'
import lancamento from './modules/lancamento.js'
import formulario from './modules/formulario.js'
import storage from './modules/storage.js'
import layout from "@/store/modules/layout";
import organizacao from "@/store/modules/organizacao";
import prestacaoConta from "@/store/modules/prestacaoConta";
import resumoProjeto from "@/store/modules/resumoProjeto";
import pessoaAlcancada from "@/store/modules/pessoaAlcancada";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {},
    getters,
    actions,
    mutations,
    modules: {
        layout,
        auth,
        usuario,
        projeto,
        logicaIntervencao,
        indicador,
        monitoramento,
        enums,
        notification: notification,
        lancamento: lancamento,
        formulario: formulario,
        storage: storage,
        organizacao: organizacao,
        prestacaoConta: prestacaoConta,
        resumoProjeto: resumoProjeto,
        pessoaAlcancada: pessoaAlcancada
    },
})

